import React, { useState } from 'react';
import IconButton from "../interactive/IconButton";
import SvgIcon from "../images/SvgIcon";
import { generateModifierClasses } from "../../modules/utils";
const FlashMessage = ({ body, message, messageList, shown = true, title = null, type = null }) => { const [dismissed, setDismissed] = useState(!shown); const validType = () => { if (type == 'notice') {
    return 'info';
}
else if (!type || ['success', 'info', 'failure'].indexOf(type) === -1) {
    return 'failure';
}
else {
    return type;
} }; const validTitle = () => { if (!title) {
    switch (validType()) {
        case 'success': return 'Success';
        case 'info': return 'Info';
        default: return 'Attention';
    }
} return title; }; const flashClasses = () => { const modifiers = [validType()]; if (dismissed)
    modifiers.push('hidden'); return generateModifierClasses('flash', modifiers); }; const renderIcon = () => { switch (validType()) {
    case 'success': return /*#__PURE__*/ React.createElement(SvgIcon, { alt: "Success", name: "approval" });
    case 'info': return /*#__PURE__*/ React.createElement(SvgIcon, { alt: "Info", name: "info-thin" });
    default: return /*#__PURE__*/ React.createElement(SvgIcon, { alt: "Attention", name: "attention" });
} }; const renderBody = () => { const children = []; if (message) {
    children.push(/*#__PURE__*/ React.createElement("p", { className: "flash__text", key: "message" }, message));
} if (body) {
    children.push(/*#__PURE__*/ React.createElement("p", { className: "flash__text", key: "body", dangerouslySetInnerHTML: { __html: body } }));
} if (messageList && messageList.length) {
    children.push(/*#__PURE__*/ React.createElement("ul", { className: "flash__list", key: "ul" }, messageList.map((msg, index) => /*#__PURE__*/ React.createElement("li", { key: `li-${index}` }, msg))));
} return children.length ? children : null; }; return /*#__PURE__*/ React.createElement("div", { className: flashClasses() }, /*#__PURE__*/ React.createElement("div", { className: "flash__icon" }, renderIcon()), /*#__PURE__*/ React.createElement("div", { className: "flash__inner" }, /*#__PURE__*/ React.createElement("p", { className: "flash__title" }, validTitle()), renderBody()), /*#__PURE__*/ React.createElement(IconButton, { alt: "Dismiss", icon: "close-thin", modifiers: ['blank', 'transparent'], onClick: () => setDismissed(true) })); };
export default FlashMessage;
